import { Outlet } from "react-router-dom";
import { useNetworkStatusMonitor } from "@/hooks/tauri/useNetworkStatusMonitor";
import { useIntl } from "@/infra/locale";
import { OfflinePage, useIsOffline } from "@akina/presentation";
import { isApp } from "@akina/utils";

export const ConnectionStatusPage = () => {
  const { formatMessage } = useIntl();
  const isOffline = useIsOffline(state => state.isOffline);
  useNetworkStatusMonitor();

  if (!isApp) return <Outlet />;
  return (
    <div className="relative">
      <div className={`${isOffline ? "pointer-events-none opacity-0" : ""}`}>
        <Outlet />
      </div>
      {isOffline ? (
        <div className="absolute inset-0 z-9999">
          <OfflinePage formatMessage={formatMessage} />
        </div>
      ) : null}
    </div>
  );
};
